import { Button } from '@/components'
import DialogRegisterQuestionnaire from '@/components/Dialog/DialogRegisterQuestionnaire'
import Checkbox from '@/components/Form/Checkbox'
import Input from '@/components/Form/Input'
import Radio from '@/components/Form/Radio'
import Select from '@/components/Form/Select'
import { availableState } from '@/features/authSlice'
import { dialogRegisterQuestionnaireState } from '@/features/dialogSlice'
import { raundUrl } from '@/lib/custom'
import { getCacheQrcode } from '@/lib/getCacheQrcode'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useFetchGet, useFetchPost } from '@/lib/useFetch'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import React, { useState, useEffect } from 'react'
import { useForm as registerUseForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useSWRConfig } from 'swr'

const RegisterQuestionnaire = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY, LOCAL_STORAGE_QRCODE_KEY } = useCampaignSlug()
  const { getWithAuth: getQuestionnairesType } = useFetchGet<Api.QuestionnairesResBody>({})
  const { getWithAuth: getQuestionnairesAnswerType } = useFetchGet<any>({})

  const { mutate } = useSWRConfig()
  const [errorState, setErrorState] = useState<Api.DefaultResBody>({
    status: 0,
    message: '',
    code: 'error',
  })
  const { postWithAuth: postQuestionnairesAnswerType } = useFetchPost<Api.DefaultResBody>({})

  const [RegisterQuestState, setRegisterQuestState] =
    useState<Pick<Api.QuestionnairesResBody, 'questionnaires'>['questionnaires']>()

  /**
   * 初回アカウント登録アンケート
   */

  useEffect(() => {
    const questionnaires = async () => {
      // 回答してるかどうか
      const res: Api.DefaultResBody = await getQuestionnairesAnswerType(`${raundUrl.questionnairesAnswerType}/1`)

      if (res?.status === 404 || res?.code === 'answered') {
        // 存在しないまたは回答済み
        localStorage.setItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY, 'answered')
        dispatch(dialogRegisterQuestionnaireState(false))
        clearAllBodyScrollLocks()
        getCacheQrcode(LOCAL_STORAGE_QRCODE_KEY)
        return
      }

      if (res?.code === 'unanswered') {
        dispatch(dialogRegisterQuestionnaireState(true))
      }
    }
    questionnaires()
    ;(async () => {
      // アンケート情報取得 404はアンケートなし
      const res: Api.QuestionnairesResBody = await getQuestionnairesType(`${raundUrl.questionnairesType}/1`)

      if (res?.status === 404) {
        localStorage.setItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY, 'answered')
        dispatch(dialogRegisterQuestionnaireState(false))
        clearAllBodyScrollLocks()
        getCacheQrcode(LOCAL_STORAGE_QRCODE_KEY)
        return
      }

      if (localStorage.getItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY)) {
        dispatch(dialogRegisterQuestionnaireState(false))
        clearAllBodyScrollLocks()
        getCacheQrcode(LOCAL_STORAGE_QRCODE_KEY)
        return
      }

      dispatch(availableState(false))
      setRegisterQuestState(res?.questionnaires)
    })()
  }, [])

  const { register, handleSubmit } = registerUseForm()

  const onSubmitDialog = async (data: { [s: string]: string } | ArrayLike<string[]>) => {
    const answerArray = []
    let answerValue: string[]
    for (let i = 0; i <= Object.keys(data).length - 1; i++) {
      if (Object.values(data)[i] === null) {
        answerValue = []
      } else if (typeof Object.values(data)[i] === 'object') {
        // listなどの配列の場合
        answerValue = Object.values(data)[i]
      } else {
        // 文字列の場合
        answerValue = [Object.values(data)[i]]
      }

      const answer = {}
      answer['id'] = Object.keys(data)[i]
      answer['answer'] = answerValue
      answerArray.push(answer)
    }

    const registerQuestionnaires = async () => {
      // アンケート回答
      const res: Api.DefaultResBody = await postQuestionnairesAnswerType(`${raundUrl.questionnairesAnswerType}/1`, {
        questionnaireItemAnswer: answerArray,
      } as Api.QuestionnairesAnswerReqBody)

      mutate(`${raundUrl.questionnairesAnswerType}/1`)

      if (res.status === 400) {
        setErrorState(res)
      }

      if (res.status === 200 || res.status === 404) {
        dispatch(dialogRegisterQuestionnaireState(false))
        clearAllBodyScrollLocks()
        localStorage.setItem(LOCAL_STORAGE_REGISTER_QUESTIONNAIRES_KEY, 'answered')
        getCacheQrcode(LOCAL_STORAGE_QRCODE_KEY)
      }
    }

    registerQuestionnaires()
  }

  if (RegisterQuestState === undefined) return <div>{''}</div>
  if (!RegisterQuestState) return <div>{''}</div>

  return (
    <DialogRegisterQuestionnaire
      title={`${RegisterQuestState.title}`}
      description={
        RegisterQuestState.description
          ? RegisterQuestState.description
          : t(
              'register_questionnaire.simple_survey',
              'イベントをより良いものにするために簡単なアンケートにお答えください。',
            )
      }
      closeButtonOff={true}
    >
      <p className="questerror mt-5 text-xs">{errorState.message}</p>

      <form className="mt-4" method="" action="" onSubmit={handleSubmit(onSubmitDialog)}>
        <fieldset>
          {RegisterQuestState &&
            RegisterQuestState.items.map((content, i) => {
              let formValueSplit = []
              if (content.formValue !== null) {
                formValueSplit = content.formValue
              }

              if (content.formType == 1) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={i}>
                    <span className="text-sm text-black">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: `${content.question} ${content.isRequired == true ? '*' : ''}`,
                        }}
                      />
                    </span>
                    <div>
                      <Input
                        labelName={`${formValueSplit[0]}`}
                        htmlfor={`${content.id}`}
                        type="text"
                        placeholder=""
                        register={register}
                      />
                    </div>
                  </div>
                )
              }

              if (content.formType == 2) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={i}>
                    <span className="text-sm text-black">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: `${content.question} ${content.isRequired == true ? '*' : ''}`,
                        }}
                      />
                    </span>
                    <div>
                      <Checkbox htmlfor={`${content.id}`} register={register} formValueSplit={formValueSplit} />
                    </div>
                  </div>
                )
              }

              if (content.formType == 3) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={i}>
                    <span className="text-sm text-black">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: `${content.question} ${content.isRequired == true ? '*' : ''}`,
                        }}
                      />
                    </span>
                    <div>
                      <Radio htmlfor={`${content.id}`} register={register} formValueSplit={formValueSplit} />
                    </div>
                  </div>
                )
              }
              if (content.formType == 4) {
                return (
                  <div className={`relative ${content.id >= 2 ? 'mt-6' : ''}`} key={content.id}>
                    <label className="mt-3 block">
                      <span className="text-sm text-black">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: `${content.question} ${content.isRequired == true ? '*' : ''}`,
                          }}
                        />
                      </span>
                      <div className="c-select_wrap relative">
                        <Select labelName={`${content.id}`} formValueSplit={formValueSplit} register={register} />
                      </div>
                    </label>
                  </div>
                )
              }

              if (content.formType == 5) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={content.id}>
                    <label className="mt-3 block">
                      <span className="text-sm text-black">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: `${content.question} ${content.isRequired == true ? '*' : ''}`,
                          }}
                        />
                      </span>
                      <div className="relative">
                        <textarea
                          name={content.id}
                          className="c-textarea_wrap"
                          id=""
                          {...register(`${content.id}`)}
                        ></textarea>
                      </div>
                    </label>
                  </div>
                )
              }
            })}
        </fieldset>
        <Button text={t('register_questionnaire.answer', '回答する')} type="submit" classes="mt-10" />
      </form>
    </DialogRegisterQuestionnaire>
  )
}

export default RegisterQuestionnaire
